import React, { FunctionComponent, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./Integration.module.css";
import { themeColors } from "../../Components/theme";
import FacebookLogin from "react-facebook-login";
import { FacebookProvider, LoginButton, Like } from 'react-facebook';
import { fetchApi } from "../../Services/organizations";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import iconFacebook from '../../Assets/Images/fbicon.png'
import acresImages from '../../Assets/Images/99acresImages.png'
import magicbricksicon from '../../Assets/Images/magicbricksicon.png'
import housingIcon from '../../Assets/Images/housingIcon.png'
import JDimages from '../../Assets/Images/JDimages.png'
import skh from '../../Assets/Images/skh.png'
import iconWeb from '../../Assets/Images/iconWeb.jpg'
import Loading from "../../Components/Loading/Loading";
import WhatsappLogo from "../../Assets/Images/Whatsapp_logo.jpg"
import { fetchLeadsResources } from "../../Services/resources";
import "../../theme-vars.css";
import { useMediaQuery } from "@material-ui/core";

type props = {
  user: any;
  contacts: any;
  history: any;
  role: any;
  organizationUsers: any;
  teamLeadUsers: any;
  theme: any;
  facebookUesrPageList: any;
};
const loginButtonStyles = {
  backgroundColor: '#272944',
  color: 'white',
  padding: '10px 20px',
  borderRadius: '5px',
  cursor: 'pointer',
};
const IntegrationFacebook: FunctionComponent<props> = ({
  user,
  contacts,
  history,
  role,
  organizationUsers,
  teamLeadUsers,
  theme,
  facebookUesrPageList
}) => {
  const dispatcher = useDispatch();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const [loginStatus, setLoginStatus] = useState<boolean>(false);
  const [API, setAPI] = useState<any[] | undefined>(undefined);
  const [showLoader, setShowLoader] = useState(true);
  const [selectedOption, setSelectedOption] = useState('');
  const [leadSourceList, setLeadSourceList] = useState<any[] | undefined>(undefined);

  const handleSelectChange = (event: any) => {
    setSelectedOption(event.target.value);
  };

  useEffect(() => {
    if (user.organization_id) {
      const unsub = fetchLeadsResources(
        (data) => setLeadSourceList(data),
        user.organization_id
      );
      return () => {
        unsub();
      };
    }
  }, [user.organization_id]);

  useEffect(() => {
    if (user.organization_id) {
      fetchApi(user.organization_id, (val) => setAPI(val));
    }
  }, [user.organization_id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    loginStatusCheck();
  }, [])

  const loginStatusCheck = () => {
    window.FB.getLoginStatus(function (response: any) {
      if (response.status === 'connected') {
        setLoginStatus(true);
      } else if (response.status === 'not_authorized') {
        console.log('Not Authorized user');
      }
      else {
        console.log('user does not logged in to Facebook');
      }
    });
  }
  const containerStyles = {
    backgroundColor: theme
      ? themeColors.backgroundColor
      : themeColors.backgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };
  const cardContainerStyles = {
    backgroundColor: theme
      ? themeColors.cardBackgroundColor
      : themeColors.cardBackgroundColorDark,
    color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
  };

  const buttonStyle = {
    backgroundColor: 'blue',
    color: 'white',
    padding: '10px 20px',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
  };
  const handleFaceBookConnect = () => {
    history.push("/facebook-leads")
  }
  const handle99AcersConnect = () => {
    history.push("/99acres", { data: leadSourceList });
  }
  const handleJustdialConnect = () => {
    history.push("/justdial", { data: leadSourceList })
  }
  const handleWebsiteConnect = () => {
    history.push("/website", { data: leadSourceList })
  }
  const handleSulekhaConnect = () => {
    history.push("/sulekha", { data: leadSourceList })
  }
  const handleHousingConnect = () => {
    history.push("/housing", { data: leadSourceList })
  }
  const handleMagicbricksConnect = () => {
    history.push("/magicbricks", { data: leadSourceList })
  }

  const handleWhatAppConnect = () => {
    history.push("/whatsapp-leads", { data: leadSourceList })
  }

  const cardWidth = isMobile ? "100%" : "45%";
  const cardMarginLeft = isMobile ? "0" : "2%";
  const cardContainerResponsive = isMobile
    ? {
      width: "100%",
      margin: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
    : { width: "87%" };
  const parentResponsive = isMobile
    ? { paddingLeft: "12px", paddingRight: "12px" }
    : {};
  const outerBlockResponsive = isMobile
    ? { margin: "20px 0px 20px 0px" }
    : { margin: "20px 0px 20px 50px" };

  return (
    <>
      {isMobile && showLoader && <Loading />}
      <div
        className={styles.parent}
        style={{ ...containerStyles, ...parentResponsive, marginTop: isMobile ? "6%" : "4%", overflow: "hidden", maxHeight: "500px", overflowX: "hidden", overflowY: "scroll", marginBottom: "10px" }}
      >
        {!isMobile && showLoader && <Loading />}
        {/* outer block */}
        <div style={{ width: "100%", display: "flex", alignItems: "flex-start", justifyContent: "flex-start", flexDirection: "column", ...outerBlockResponsive }}>
          <h4 style={{
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-large)",
            margin: isMobile ? "10px 10px 10px 10px" : "0px 0 12px 0"
          }}>Integrations</h4>
          <div style={{ ...containerStyles, ...cardContainerResponsive, boxShadow: isMobile ? undefined : "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px", borderRadius: "10px", justifyContent: "flex-start", alignItems: "flex-start", height: "auto", paddingBottom: "50px", marginBottom: "50px" }}>
            {/* sub block */}
            <div style={{ width: "auto", display: "flex", alignItems: "flex-start", justifyContent: "flex-start", flexDirection: "column" }}>
              <div style={{ display: "flex", width: "100%", height: "auto", alignItems: "flex-start", justifyContent: "flex-start", flexWrap: "wrap", marginTop: "10px" }}>
                {/* Lead block */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}>
                    <div> <img src={iconFacebook}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>Facebook</h2>
                  </div>
                  <div className="mb-1" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)",
                  }}>
                    {/* Receive new leads from your Facebook &amp; Lead Ads into
                    your Lead Rubix account. */}
                    Receive new leads from Facebook in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    {loginStatus === true ? <>
                      <a style={{
                        color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                        fontSize: "var(--font-size-small)"
                      }}
                        onClick={handleFaceBookConnect}>Connected
                        <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                      </a>
                    </> : <>
                      <a style={{
                        color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                        fontSize: "var(--font-size-small)"
                      }}
                        onClick={handleFaceBookConnect}>Configure
                        <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                      </a>
                    </>}
                  </div>
                </div>
                {/* new card2 */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}>
                    <div> <img src={acresImages}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>99Acres</h2>
                  </div>
                  <div className="mb-1" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from 99Acres in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}
                      onClick={handle99AcersConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>
                {/* new card2 */}
              </div>
              <div style={{ display: "flex", width: "100%", height: "auto", alignItems: "flex-start", justifyContent: "flex-start", flexWrap: "wrap", marginTop: "10px" }}>
                {/* Lead block */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",

                  }}>
                    <div> <img src={magicbricksicon}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>MagicBricks</h2>
                  </div>
                  <div className="mb-2" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from MagicBricks in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}
                      onClick={handleMagicbricksConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>
                {/* new card2 */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}>
                    <div> <img src={housingIcon}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>Housing.com</h2>
                  </div>
                  <div className="mb-2" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from Housing.com in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}
                      onClick={handleHousingConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>
                {/* new card2 */}
              </div>
              <div style={{ display: "flex", width: "100%", height: "auto", alignItems: "flex-start", justifyContent: "flex-start", flexWrap: "wrap", marginTop: "10px" }}>
                {/* Lead block */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",

                  }}>
                    <div> <img src={JDimages}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>JustDial</h2>
                  </div>
                  <div className="mb-2" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from JustDial in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}
                      onClick={handleJustdialConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>
                {/* new card2 */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                  }}>
                    <div> <img src={skh}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>Sulekha</h2>
                  </div>
                  <div className="mb-2" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from Sulekha in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}
                      onClick={handleSulekhaConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>
                {/* new card2 */}
              </div>
              <div style={{ display: "flex", width: "100%", height: "auto", alignItems: "flex-start", justifyContent: "flex-start", flexWrap: "wrap", marginTop: "10px" }}>
                {/* Lead block */}
                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div style={{
                    // ...containerStyles,
                    width: "100%",
                    height: "35px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",

                  }}>
                    <div> <img src={iconWeb}
                      width={30}
                      className="mx-auto my-6 w-60">
                    </img></div>
                    <h2 style={{
                      paddingLeft: "8px", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-medium)", marginTop: "8px"
                    }}>Website</h2>
                  </div>
                  <div className="mb-2" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from your website’s contact form in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}
                      onClick={handleWebsiteConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>

                <div
                  style={{
                    ...containerStyles,
                    padding: "10px 20px",
                    width: cardWidth,
                    marginLeft: cardMarginLeft,
                    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                    borderRadius: "10px",
                    marginBottom: isMobile ? "16px" : undefined
                  }}
                >
                  {/* facebook icon and heading main block */}
                  <div
                    style={{
                      width: "100%",
                      height: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* Left side: Icon + Text */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={WhatsappLogo}
                        width={30}
                        alt="WhatsApp"
                        style={{ marginRight: "8px" }}
                      />

                      <h2
                        style={{
                          fontFamily: "var(--font-family-main)",
                          fontSize: "var(--font-size-medium)",
                          margin: 0,
                        }}
                      >
                        WhatsApp
                      </h2>
                    </div>

                    {/* Right side: Coming Soon */}
                    <span
                      style={{
                        fontSize: "12px",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        backgroundColor: "#FFF3CD",
                        color: "#856404",
                        fontWeight: 500,
                        whiteSpace: "nowrap",
                      }}
                    >
                      Coming Soon
                    </span>
                  </div>

                  <div className="mb-2" style={{
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-small)"
                  }}>
                    Receive new leads from your WhatsApp contact form in your Leads Rubix account
                  </div>
                  <div style={{ display: "flex", justifyContent: 'flex-end', width: "100%" }} >
                    <a style={{
                      color: "#106ebe", cursor: "pointer", fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)"
                    }}

                      onClick={handleWhatAppConnect}
                    >Configure
                      <ArrowForwardIosIcon style={{ width: 14, height: 14, color: "#106ebe" }} />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    theme: state.theme.isLightMode,
    facebookUesrPageList: state.faceBookUserPagesData.data,
  };
};
export default connect(mapStateToProps)(IntegrationFacebook);
